import { useMutation } from "react-query";
import { postAddTableCall } from "../requests/Tables";

export function useMutationAddTableCall() {
    const query = useMutation(postAddTableCall, {
        onSuccess: (data) => {
            if(data?.success) {
                // console.log(data)
            } else {
                // console.log(data?.errors)
            }
        }, onError: (data) => {
            console.error(data)
        }
    });
    return query;
}
